import { AmmunitionIcon } from './AmmunitionIcon';

/**
 * author: Michael Irigoyen
 * id 0F3F828D-7F80-4571-A5B5-296FAC62FFB9
 * name ammunition
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ammunition.svg
 * tags
 */
export const BulletsIcon = AmmunitionIcon;
export default BulletsIcon